<template>
  <div class="course-wrap">
    <!-- 修改后样式 -->
    <div class="video-item-box">
      <div class="video-item-title" @click="goPlay(item)">
        <div
          class="title-left-cion"
          v-if="!item.chapterList && activeIndex == index"
        >
          <van-image :src="require('@/assets/H5/play/live-icon.png')" alt="" />
        </div>
        <div
          class="title ellipsis-line-2"
          :class="!item.chapterList && activeIndex == index ? 'active' : ''"
        >
          {{ item.name }}
        </div>
        <template v-if="item.chapterList">
          <div class="show-icon-box">
            <img
              v-if="item.isShowSection"
              src="@/assets/H5/play/showup.png"
              alt=""
              class="show-icon"
            />
            <img
              v-else
              src="@/assets/H5/play/showdown.png"
              alt=""
              class="show-icon"
            />
          </div>
        </template>
        <div class="show-icon" v-else></div>
      </div>
      <!-- 视频章节 -->
      <div
        class="video-section-box"
        :style="{ 'margin-bottom': item.chapterList ? '12px' : '' }"
        v-show="item.isShowSection"
      >
        <div
          class="video-section-item"
          :class="{
            'section-border-bottom ': idx + 1 !== item.chapterList.length,
            'active-section': activeSectionId == section.id,
          }"
          v-for="(section, idx) in item.chapterList"
          :key="section.id"
          @click="goToSectionTime(section)"
        >
          <div class="section-img">
            <img
              v-if="activeSectionId == section.id"
              src="@/assets/H5/play/live-icon.png"
              alt=""
              class="icon-box"
            />
            <img
              v-else
              src="@/assets/H5/play/video-0.png"
              alt=""
              class="icon-box"
            />
          </div>
          <div class="section-title ellipsis-line-2">
            {{ section.chapterName }}
          </div>
          <div class="section-time">
            {{
              section.timeNode.slice(0, 2) > 0
                ? section.timeNode
                : section.timeNode.slice(3)
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import { timeToSecond } from "@/utils/dateFormat";
export default defineComponent({
  props: {
    item: Object,
    index: Number,
    activeIndex: [Number, String],
    isSpecial: [Boolean, Number],
    showVideoTime: [Boolean, Number],
    activeSectionId: Number,
  },
  emit: ["currentClick", "goSectionTimeNode"],
  setup(props, { emit }) {
    onMounted(async () => {});
    const goPlay = (item) => {
      let obj = {
        item: item,
        index: props.index,
      };
      // emit("clickItem", obj);
      emit("currentClick", obj);
    };
    const goToSectionTime = (section) => {
      emit("goSectionTimeNode", section);
    };
    return {
      goPlay,
      goToSectionTime,
      timeToSecond,
    };
  },
});
</script>

<style lang="less" scoped>
.ellipsis-line-1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ellipsis-line-2 {
  overflow: hidden;
  white-space: pre-wrap;
  line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.course-wrap {
  margin-bottom: 10px;
  .box {
    width: 100%;
    background: #f7f7f7;
    border-radius: 4px;
    padding: 10px;
    box-sizing: border-box;
    border: 1px solid #f7f7f7;
    &.active {
      border: 1px solid #0f3cc6;
      background: rgba(15, 60, 198, 0.15);
    }
  }
  // 修改后样式
  .video-item-title {
    display: flex;
    justify-content: space-between;
    align-items: start;
    // height: 44px;
    padding: 11px 12px;
    background: #f7f7f7;
    border-radius: 4px;
    .title-left-cion {
      width: 16px;
      height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;
      .van-image {
        width: 16px;
        height: 16px;
      }
    }
    .title {
      flex: 1;
      margin-right: 16px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222;
      line-height: 22px;
    }
    .title.active {
      color: #0f3cc6;
      // margin-right: 8px;
    }
    .show-icon-box {
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .show-icon {
      width: 12px;
      height: 12px;
    }
  }
  .video-section-box {
    // margin-bottom: 12px;
    .video-section-item {
      display: flex;
      align-items: start;
      padding: 12px 0;
      &.active-section .section-title {
        color: #0f3cc6;
        font-family: PingFangSC-Medium, PingFang SC;
      }
      .section-img {
        width: 16px;
        height: 22px;
        margin-left: 12px;
        margin-right: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon-box {
          width: 16px;
          height: 16px;
        }
      }
      .section-title {
        flex: 1;
        // height: 44px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222;
        line-height: 22px;
      }
      .section-time {
        // width: 30px;
        width: 48px;
        height: 17px;
        text-align: right;
        margin: 0 4px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9a9a9a;
        line-height: 17px;
      }
    }
    .section-border-bottom {
      border-bottom: 1px solid #f7f7f7;
    }
  }
  .image {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    margin-top: 3px;
  }

  .content {
    overflow: hidden;

    .title {
      width: 224px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 22px;
      margin-right: 24px;
    }
    .playing {
      text-align: right;
      width: 50px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0f3cc6;
      line-height: 22px;
      height: 22px;
      align-items: start;
      .icon-live {
        margin-right: 3px;
        margin-top: 5px;
      }
    }

    .active {
      color: #0f3cc6;
    }

    .sub-title {
      width: 50px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9a9a9a;
      line-height: 22px;
      height: 22px;
      text-align: right;
    }

    .mb-10 {
      margin: 0 0 5px 0;
    }
  }
}
</style>
